var IE = (!! window.ActiveXObject && +(/msie\s(\d+)/i.exec(navigator.userAgent)[1])) || NaN;
jQuery(window).ready(function(){
    if ( IE) {
        jQuery('html').addClass('ie-'+IE);
    }

    splitDescription();

    jQuery('.fake-select, .fake-select select').FakeSelect();

    // Custom inputs
    jQuery('.fake-inputbox, .fake-inputbox input:not([type="hidden"])').fakeInputBox();

    offscreens();

    jauge();

    countdown();

    catalog();

    // product colors random rotation mask
    jQuery('.product-colors .mask').each(function(i, el) {
        el = jQuery(el);
        el.addClass('rand-'+ (Math.floor(Math.random() * (4 - 1) + 1)) );
    });

    // mobile slider
    xsFlickity();

    // product media zoom
    mediasZoom();

    clrzCookieExist();

    // localizejs translate
    // var currentLang = Localize.getLanguage();
    // jQuery('[data-localize-lang="'+currentLang+'"]').addClass('current-lang');
    // Localize.on('setLanguage', function(e) {
    //     // { from: oldLang, to: newLang }
    //     currentLang = e.to;
    //     jQuery('[data-localize-lang]').removeClass('current-lang');
    //     jQuery('[data-localize-lang="'+currentLang+'"]').addClass('current-lang');
    // });


    currenciesPicker();

    // cart remove duplicate qty select
    if(jQuery('.xs-qty').length) {
        if(isMobile()) {
            jQuery('.no-xs-qty').remove();
        } else {
            jQuery('.xs-qty').remove();
        }
    }

    // cart

    setTimeout(function() {
        jQuery('.cart-liquid .js-qty__adjust').on('click', function(e) {
            jQuery('.cart-submit-update').click();
        });
    }, 300);

    // fix flickity
    fixSlider();

    // contact/faq accordeon
    faq();
    // remove ,00

//     function changePrice(){
//         jQuery('.money').each(function(){
//             jQuery(this).html(jQuery(this).html().replace(".", ",").replace(",00", "<span class='hidden'>,00</span>"));
//         });
//     }
//     setTimeout(changePrice, 200);

//     jQuery('.langs-menu-list button').click(function(){
//         setTimeout(changePrice, 200);
//     });

  	// Hover jauge

  	jQuery('.product-item').hover(function(){
    	jQuery('div#hover-jauge', this).removeClass('hidden');
  		}, function(){
   		jQuery('div#hover-jauge', this).addClass('hidden');
  	});

});
